import(/* webpackMode: "eager" */ "/vercel/path0/src/app/projects/animalia/page.tsx");
